export { DetailsTrekFamilyCarousel } from './DetailsTrekFamilyCarousel';
